export class Term {
  constructor(
    public id: string,
    public projectId: string,
    public key: string,
    public isPlural: boolean,
    public context: string | null,
    public createdAt: string,
    public deletedAt: string | null = null
  ) {}

  static fromRow(row: Record<string, any>): Term {
    return new Term(row.id, row.project_id, row.key, row.is_plural, row.context ?? null, row.created_at, row.deleted_at ?? null);
  }
}

export default Term;
